import { useState } from 'react';
import { Box, Chip, Paper, Tab, Tabs, Typography } from '@mui/material';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';

import SyncHealthTab from './SyncHealthTab';
import StreamTab from './StreamTab';
import ErrorsTab from './ErrorsTab';
import { ObsError } from './ObsError';
import { useGetObsSummaryQuery } from '../../redux/services/obs-api';

const fmtBytes = bytes => {
  if (bytes == null) return '—';
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

function SummaryBar({ data }) {
  if (!data) return null;

  const { last24h, totalEvents, storage, config } = data;
  const levels = last24h?.byLevel || {};

  return (
    <Paper sx={{ p: 1.5, mb: 2, display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
      <Typography variant="body2" sx={{ fontWeight: 600, mr: 1 }}>
        Últimas 24 h:
      </Typography>
      <Chip size="small" color="error" label={`fatal+error ${(levels.fatal || 0) + (levels.error || 0)}`} />
      <Chip size="small" color="warning" label={`warn ${levels.warn || 0}`} />
      <Chip size="small" color="info" label={`info ${levels.info || 0}`} />
      <Box sx={{ flex: 1 }} />
      <Typography variant="caption" color="text.secondary">
        {totalEvents} eventos · {fmtBytes(storage?.sizeBytes)} · persistencia ≥{config?.persistLevel}
        {config?.ingestEnabled === false ? ' · INGESTA APAGADA' : ''}
      </Typography>
    </Paper>
  );
}

function ObservabilityPage() {
  const [tab, setTab] = useState(0);
  // El resumen es la sonda de acceso de la página: si responde 403, las tres pestañas
  // van a responder lo mismo. Se pregunta una vez y no se montan — si no, tres
  // consultas con `pollingInterval` estarían golpeando el servidor cada 30 s para
  // recibir el mismo 403.
  const { data: summary, error: summaryError } = useGetObsSummaryQuery(undefined, {
    pollingInterval: 60000,
  });
  const sinAcceso = summaryError?.status === 403 || summaryError?.status === 401;

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <MonitorHeartIcon />
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Watchtower
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Telemetría de las apps y del servidor. La identidad de los eventos móviles es
        autodeclarada (sin verificar); el rastro con identidad verificada vive aparte.
      </Typography>

      {sinAcceso ? (
        <ObsError error={summaryError} />
      ) : (
        <>
          {summaryError && <ObsError error={summaryError} context="el resumen" />}
          <SummaryBar data={summary} />

          <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
            <Tab label="Salud de sincronización" />
            <Tab label="Stream de eventos" />
            <Tab label="Errores agrupados" />
          </Tabs>

          {tab === 0 && <SyncHealthTab />}
          {tab === 1 && <StreamTab />}
          {tab === 2 && <ErrorsTab />}
        </>
      )}
    </Box>
  );
}

export default ObservabilityPage;
